<template>
<div class="mock">
  <img :src="shareNote">
</div>
</template>

<script>
export default{
	name: 'mock',
	data() {
		let that = this;

		return {
			shareNote: that.$store.state.Host+'/images/static/img/intro_detail.a647db5.png'
		} 
	}
}
</script>


// WEBPACK FOOTER //
// src/components/MockShare.vue